import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { NotifyService } from '@fry/lib/utils';
import { CanComponentDeactivate } from '@fry/components/common/form';
import { VenueEditForm } from '@fry/booking/lib/venues/venue-edit.form';
import { Venue, VenuesStore } from '@fry/booking/lib';
import { ActivatedRoute, Router } from '@angular/router';
import { EasFormGroup } from '@fry/components/common/easform';

@Component({
    selector: 'eas-venue-create-edit',
    templateUrl: './venue-create.component.html',
    providers: [VenueEditForm],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VenueCreateComponent implements OnInit, CanComponentDeactivate {
  public venue: Venue;
  public formData$: Observable<FormData>;
  public easFormGroup$: Observable<EasFormGroup>;

  constructor(
    private venues: VenuesStore,
    private editForm: VenueEditForm,
    private notify: NotifyService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.venue = this.venues.blank();
    this.easFormGroup$ = this.editForm.init(this.venue);
  }

  onSubmit() {
    this.editForm.submit(this.venue).subscribe(
      data => {
        this.venue = data;
        this.notify.success($localize `New venue successfully created`);
        this.router.navigate(['..'], { relativeTo: this.route });
      },
      error => {
        console.log(error);
        this.notify.error(error);
      }
    );
  }

  canSafelyDeactivate() {
    return this.editForm.pristine;
  }
}
